import { useEffect, useState } from "react";

/**
 * Floating WhatsApp button — fixed bottom-right on every page.
 * Uses wa.me link so it opens native WhatsApp on mobile and web WhatsApp on desktop.
 */
export default function WhatsAppButton({ phone = "919650595152" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Reveal after a short delay so it doesn't fight the hero on-load motion
    const t = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${phone}?text=${encodeURIComponent(
    "Hello Njia Safaris — I'd like to speak with a specialist about a journey."
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Njia Safaris on WhatsApp"
      data-testid="whatsapp-fab"
      className={`fixed z-[70] right-5 bottom-5 md:right-7 md:bottom-7 flex items-center gap-3 pl-4 pr-5 py-3 rounded-full shadow-editorial transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{ background: "#25D366", color: "#0F1210" }}
    >
      {/* WhatsApp glyph (inline SVG) */}
      <svg
        width="22"
        height="22"
        viewBox="0 0 32 32"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.53 2.478-1.334.19-.502.29-1.084.29-1.618 0-.115 0-.244-.03-.373-.1-.156-2.35-1.16-2.723-1.16zm-2.75 8.107c-1.464 0-2.9-.386-4.15-1.13l-2.9.918.938-2.85a7.917 7.917 0 0 1-1.32-4.38c0-4.383 3.578-7.947 7.964-7.947 4.372 0 7.964 3.564 7.964 7.947 0 4.383-3.578 7.947-7.964 7.947zm0-17.4c-5.257 0-9.522 4.267-9.522 9.522 0 1.68.446 3.32 1.31 4.76L4.5 27.5l5.42-1.72a9.51 9.51 0 0 0 4.44 1.13h.02c5.256 0 9.523-4.264 9.523-9.522 0-2.548-.99-4.94-2.79-6.744-1.8-1.8-4.196-2.792-6.746-2.792z" />
      </svg>
      <span className="mono text-[10px] uppercase tracking-[0.28em] font-semibold hidden sm:inline">
        WhatsApp us
      </span>
    </a>
  );
}
